import { forwardRef } from "react";
import Link from "next/link";

export const ShallowLink = forwardRef(function ShallowLink(props, ref) {
  return <Link replace shallow scroll={false} ref={ref} {...props} />;
});
